import {
  createValidator,
  Rules,
  required,
  date,
  maxDate,
  minDate,
  betweenDates,
  pattern,
  minLength,
  maxLength,
} from 'src/helpers/validation';
import { getConsentDOB } from 'src/helpers/date';
import { ConfirmIdentityFormData } from 'src/components/ConfirmIdentityForm/ConfirmIdentityForm';

export const gbPostCodePattern = /GIR[ ]?0AA|((AB|AL|B|BA|BB|BD|BH|BL|BN|BR|BS|BT|CA|CB|CF|CH|CM|CO|CR|CT|CV|CW|DA|DD|DE|DG|DH|DL|DN|DT|DY|E|EC|EH|EN|EX|FK|FY|G|GL|GY|GU|HA|HD|HG|HP|HR|HS|HU|HX|IG|IM|IP|IV|JE|KA|KT|KW|KY|L|LA|LD|LE|LL|LN|LS|LU|M|ME|MK|ML|N|NE|NG|NN|NP|NR|NW|OL|OX|PA|PE|PH|PL|PO|PR|RG|RH|RM|S|SA|SE|SG|SK|SL|SM|SN|SO|SP|SR|SS|ST|SW|SY|TA|TD|TF|TN|TQ|TR|TS|TW|UB|W|WA|WC|WD|WF|WN|WR|WS|WV|YO|ZE)(\d[\dA-Z]?[ ]?\d[ABD-HJLN-UW-Z]{2}))|BFPO[ ]?\d{1,4}/i;
export const minDob = '1900-01-01';
const dobConsentDate = getConsentDOB(13);
const namePattern = /^[a-z'\- ]+$/i;

const commonRules: Rules<ConfirmIdentityFormData> = {
  firstName: [
    required({ message: 'Please include your first name' }),
    minLength(2),
    maxLength(30),
    pattern(namePattern, { message: 'Please enter a valid first name' }),
  ],
  lastName: [
    required({ message: 'Please include your last name' }),
    minLength(2),
    maxLength(30),
    pattern(namePattern, { message: 'Please enter a valid last name' }),
  ],
  dob: [
    required({
      message: 'Please include your date of birth',
      emptyValues: ['__/__/____'],
    }),
    date({ message: 'Please make sure this is a valid date' }),
    maxDate(dobConsentDate, {
      message: 'If you are under 18 you must have parental consent.',
    }),
    minDate(minDob, { message: 'Please make sure this is a valid date' }),
    betweenDates(dobConsentDate, getConsentDOB(18), {
      message: 'If you are under 18 you must have parental consent.',
    }),
  ],
  country: [required({ message: 'Please select your country' })],
  addressLine1: [
    required({ message: 'Please include the first line of your address' }),
  ],
  city: [required({ message: 'Please include your city' })],
  confirmJustGivingTermsService: [
    required({
      message:
        'Please confirm you agree to the JustGiving Terms of Service and Privacy Policy',
    }),
  ],
};

const gbRules = {
  ...commonRules,
  postalCode: [
    required({ message: 'Please include your postcode' }),
    pattern(gbPostCodePattern, {
      message: 'Please enter a valid postcode',
    }),
  ],
  confirmFundraisingRegulatorGuidance: [
    required({
      message:
        "Please confirm you have read the Fundraising Regulator's Guidance Notes",
    }),
  ],
};

const usRules = {
  ...commonRules,
  state: [required({ message: 'Please include your state' })],
  postalCode: [
    required({ message: 'Please include your zip code' }),
    pattern(/^\d{5}(?:[-\s]\d{4})?$/, {
      message: 'Please enter a valid zip code',
    }),
  ],
};

const auRules = {
  ...commonRules,
  state: [required({ message: 'Please include your state' })],
  postalCode: [
    required({ message: 'Please include your postcode' }),
    pattern(/^\d{4}$/, {
      message: 'Please enter a valid postcode',
    }),
  ],
};

export default {
  GB: createValidator<ConfirmIdentityFormData>(gbRules),
  US: createValidator<ConfirmIdentityFormData>(usRules),
  AU: createValidator<ConfirmIdentityFormData>(auRules),
};



// WEBPACK FOOTER //
// ./src/components/ConfirmIdentityForm/confirmIdentityValidator.tsx